import React, { useEffect } from 'react';

import { Center } from '@mantine/core';
import { useInViewport } from '@mantine/hooks';

import { Loader } from '../../../../Feedback';

type NextPageLoaderProps = {
  hasNextPage: boolean;
  isFetchingNextPage: boolean;
  handleFetchNextPage: () => void;
};

const NextPageLoader = ({
  hasNextPage,
  isFetchingNextPage,
  handleFetchNextPage,
}: NextPageLoaderProps) => {
  const { ref, inViewport } = useInViewport();

  useEffect(() => {
    if (inViewport && hasNextPage && !isFetchingNextPage) {
      handleFetchNextPage();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inViewport, isFetchingNextPage, hasNextPage]);

  return (
    <Center ref={ref} py="xl">
      {isFetchingNextPage && <Loader />}
    </Center>
  );
};

const NextPageLoaderWrapper = React.memo((props: NextPageLoaderProps) => {
  if (!props.hasNextPage) return null;
  return <NextPageLoader {...props} />;
});

export { NextPageLoaderWrapper as NextPageLoader };
